/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import { styles } from './index.styles'
import Terms from './views/partials/Terms'
import PageHeader from './views/partials/PageHeader'
import QuestionPageWrapper from './views/QuestionPageWrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import InfoCards from './views/partials/InfoCards'
import queryString from 'query-string'
import { Button, Grid, Paper, Box, Typography, TextField } from '@material-ui/core'
import Research from './views/partials/Research'

class FullPageQuestionApplication extends PureComponent {
    state = {
        baseUrl: null,
        contentAlias: null,
        message: '',
        phone: '',
        email: '',
        messageSent: false
    }

    componentDidMount() {
        const parsedQueryString = queryString.parse(window.location.search)
        const contentAlias = parsedQueryString && parsedQueryString['ca'] ? parsedQueryString['ca'] : null

        delete parsedQueryString.ca
        const baseUrl = window.location.pathname + '?' + queryString.stringify(parsedQueryString)

        this.setState({ baseUrl: baseUrl, contentAlias: contentAlias })
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value, messageSent: false })
    }

    onSubmitMessage = () => {
        const { message, phone, email } = this.state
        console.log('submit', message, phone, email)
        axios
            .post(`/contact`, { message, phone, email })
            .then(res => {
                this.setState({ messageSent: true, message: '', phone: '', email: '' })
            })
            .catch(res => {
                alert('Error on sending the message. You can contact us by email: contact@leadspark.io')
            })
    }

    render() {
        const {
            classes,
            layout,
            questionPage,
            onNext,
            childNext,
            childPrev,
            pageAlias,
            isLoading,
            activeStep,
            visitorSessionId,
            theme,
            previewQuestionPages
        } = this.props

        const { baseUrl, contentAlias, message, phone, email, messageSent } = this.state

        const renderContentTutkimukset = (
            <Grid container className={classes.container}>
                <Grid item xs={12} sm={12}>
                    <Box px={{ xs: 2, md: 0 }}>
                        <Typography variant="h1">Tutkimuksemme</Typography>
                        <Typography variant="body1" style={{ marginBottom: 16 }}>
                            Tuotamme kattavaa, ajantasaista ja luotettavaa tietoa talouden monimuotoisista ilmiöistä. Tehtävämme on auttaa kuluttajia
                            ja yrityksiä ymmärtämään paremmin taloudellista ympäristöä, jossa he toimivat, ja tekemään tietoon perustuvia päätöksiä.
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 16 }}>
                            Palvelumme kattaa laajan kirjon taloustieteellisiä tutkimusalueita, mukaan lukien kuluttajakäyttäytymisen ja
                            markkinatrendien analysoinnin. Tutustu toimintaamme ja teetä oma tutkimuksesi ottamalla yhteyttä!
                        </Typography>
                        <a href={baseUrl}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                className="forwardButton"
                                style={{ fontSize: '1rem', marginTop: 8, marginBottom: 16 }}
                            >
                                Osallistu nykyiseen tutkimukseemme
                                <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', 'long-arrow-alt-right']} />
                            </Button>
                        </a>
                        <Research showSlogansLast />
                    </Box>
                </Grid>
            </Grid>
        )

        const renderContentTeetaOmaTutkimus = (
            <Grid container className={classes.container}>
                <Grid item xs={12} sm={6}>
                    <Box px={{ xs: 2, md: 0 }}>
                        <Typography variant="h1">Teetä oma tutkimus</Typography>
                        <Typography variant="body1" style={{ marginBottom: 16 }}>
                            Haluatko ymmärtää paremmin markkinoita, kuluttajien käyttäytymistä tai talouden trendejä? Tutkimuskeskus tarjoaa
                            ainutlaatuisen ja innovatiivisen alustan, jonka avulla voit itse teettää tutkimuksia ja saada arvokasta tietoa
                            liiketoimintasi tai tutkimuksesi tueksi.
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 16 }}>
                            Teknologiamme on suunniteltu olemaan käyttäjäystävällinen, joustava ja tehokas. Se mahdollistaa monenlaisten
                            tutkimusten toteuttamisen, oli kyseessä sitten markkinoiden segmentointi, hinta-analyysi, kuluttajatyytyväisyyden
                            mittaus tai taloudellisen kehityksen seuranta. Voit mukauttaa tutkimuksesi juuri sinun tarpeidesi mukaiseksi.
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Box px={{ xs: 2, md: 0 }} pb={4} pl={{ xs: 2, md: 8 }}>
                        <Paper>
                            <Box px={2} display="flex" flexDirection="column" style={{ gap: 8 }}>
                                <Typography variant="h5">Ota yhteyttä</Typography>
                                {messageSent && <Box style={{ fontSize: '1rem', fontWeight: 600, color: '#006600' }}>Viesti lähetetty!</Box>}
                                <Typography variant="body2" gutterBottom>
                                    Vastaamme kahden arkipäivän kuluessa.
                                </Typography>
                                <TextField variant="outlined" label="Sähköpostiosoite" name="email" onChange={this.handleChange} value={email} />
                                <TextField variant="outlined" label="Puhelinnumero" name="phone" onChange={this.handleChange} value={phone} />
                                <TextField
                                    variant="outlined"
                                    label="Viesti"
                                    multiline
                                    rows={5}
                                    name="message"
                                    onChange={this.handleChange}
                                    className={classes.textArea}
                                    value={message}
                                />
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    className="forwardButton"
                                    style={{ fontSize: '1rem', marginTop: 12, marginBottom: 16, marginLeft: 'auto' }}
                                    onClick={this.onSubmitMessage}
                                >
                                    Lähetä viesti
                                    <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', 'long-arrow-alt-right']} />
                                </Button>
                            </Box>
                        </Paper>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Box px={{ xs: 2, md: 0 }} pb={4}>
                        <Typography variant="h5" style={{ marginBottom: 16 }}>
                            Kuinka Aloittaa?
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 16 }}>
                            <b>Ota yhteyttä, Rekisteröidy ja Luo Profiili:</b> Aloita ottamalla yhteyttä, rekisteröitymällä palveluumme ja luomalla
                            käyttäjäprofiili. Täytä tarvittavat tiedot ja kerro meille, minkä tyyppistä tutkimusta olet kiinnostunut tekemään.
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 16 }}>
                            <b>Määrittele tutkimuksen tavoitteet ja parametrit:</b> Seuraavaksi sinun tulee määritellä tutkimuksesi tavoitteet ja
                            asettaa tarvittavat parametrit. Alustamme auttaa sinua ymmärtämään, mitkä tekijät ovat oleellisia juuri sinun
                            tutkimuksellesi, ja ohjaa sinua valitsemaan oikeat muuttujat ja mittarit.
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 16 }}>
                            <b>Valitse datalähteet ja metodologia:</b> Valitse laajasta tietokannastamme ne datalähteet, jotka sopivat parhaiten tutkimuksesi
                            tarpeisiin. Voit myös tuoda omia datalähteitäsi. Valitse sitten sopiva analyysimetodologia. Jos et ole varma, mikä
                            menetelmä sopisi parhaiten, asiantuntijatiimimme on valmis auttamaan ja neuvomaan sinua.
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 16 }}>
                            <b>Suorita analyysi ja tulkitse tulokset:</b> Kun kaikki on valmista, voit suorittaa analyysin. Teknologiamme käsittelee
                            tiedot nopeasti ja tehokkaasti, ja saat tulokset käyttöösi selkeässä ja visuaalisesti houkuttelevassa muodossa. Opi
                            tulkkaamaan tuloksia ja ymmärtämään, mitä ne tarkoittavat liiketoimintasi tai tutkimuksesi kannalta.
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: 16 }}>
                            <b>Jaa ja hyödynnä tuloksia:</b> Lopuksi voit jakaa tulokset tiimisi tai sidosryhmiesi kanssa ja käyttää niitä päätöksenteon
                            tukena. Tulokset ovat myös tallennettuina tilillesi, joten voit palata niihin myöhemmin tarvittaessa.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        )

        return (
            <div className={classes.root + ' questionApplicationRoot layout-' + layout} key={'questionApp'}>
                <PageHeader questionPage={questionPage} baseUrl={baseUrl} />
                {contentAlias ? (
                    <>
                        {contentAlias === 'tutkimukset' && renderContentTutkimukset}
                        {contentAlias === 'teeta-oma-tutkimus' && renderContentTeetaOmaTutkimus}
                    </>
                ) : (
                    <>
                        <Grid container className={classes.container}>
                            <Grid item xs={12} sm={8}>
                                <Paper className={classes.wrapper + ' ' + classes.paper + ' questionApplicationWrapper'} elevation={1}>
                                    {!questionPage && (
                                        <div className={classes.loaderWrapper}>
                                            <FontAwesomeIcon size="2x" icon={['far', 'spinner-third']} spin className={classes.loadingSpinner} />
                                        </div>
                                    )}
                                    {!previewQuestionPages && questionPage && (
                                        <QuestionPageWrapper
                                            questionPage={questionPage}
                                            questionPageRef={questionPage}
                                            pageAlias={pageAlias}
                                            isLoading={isLoading}
                                            activeStep={activeStep}
                                            onNext={onNext}
                                            childNext={childNext}
                                            childPrev={childPrev}
                                            visitorSessionId={visitorSessionId}
                                            theme={theme}
                                            layout={layout}
                                        />
                                    )}
                                    {previewQuestionPages &&
                                        previewQuestionPages.map((previewQuestionPage, key) => (
                                            <>
                                                <QuestionPageWrapper
                                                    questionPage={previewQuestionPage}
                                                    questionPageRef={this.questionPage}
                                                    pageAlias={pageAlias}
                                                    isLoading={isLoading}
                                                    activeStep={activeStep}
                                                    onNext={this.onNext}
                                                    childNext={this.childNext}
                                                    childPrev={this.childPrev}
                                                    visitorSessionId={visitorSessionId}
                                                    theme={theme}
                                                    layout={layout}
                                                    isPreview={key !== 0}
                                                    key={key}
                                                />
                                                {key !== previewQuestionPages.length - 1 && <Box className={classes.fullPageDivider}></Box>}
                                            </>
                                        ))}
                                </Paper>
                                {questionPage && questionPage.termsPosition === 'below' && (
                                    <Box mx={{ xs: 1, sm: 2 }} mt={2}>
                                        <Terms domain={questionPage.domain} theme={theme} layout={layout} />
                                    </Box>
                                )}
                            </Grid>
                            {questionPage && questionPage.sidebarContentUpper && (
                                <Grid item xs={12} sm={4} className={classes.infoCardWrapper}>
                                    <InfoCards infoCards={questionPage.sidebarContentUpper} />
                                </Grid>
                            )}
                        </Grid>
                        {Boolean(theme?.is_extra_elements_visible) && (
                            <Grid container className={classes.container}>
                                <Grid item xs={12} sm={8}>
                                    <Research />
                                </Grid>
                                {questionPage && questionPage.sidebarContentLower && (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={4}
                                        className={classes.hideOnMobile + ' ' + classes.infoCardWrapper}
                                        style={{ paddingTop: 24 }}
                                    >
                                        <InfoCards infoCards={questionPage.sidebarContentLower} />
                                    </Grid>
                                )}
                            </Grid>
                        )}
                    </>
                )}
            </div>
        )
    }
}

export default withStyles(styles)(FullPageQuestionApplication)
